export default __webpack_public_path__ + "maps-examples-source-custom-vector-960-1fc1717d91c6478e9f3a6aab5d30de38.webp";